import styled from '@eduzz/houston-styles/styled';

export const Container = styled.li<{ isClubeBlack: boolean }>`
  list-style: none;
  width: 100%;
  display: flex;

  align-items: center;
  padding: 11px 17px;
  text-align: left;
  user-select: none;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  a {
    color: #fff;
    padding: 0 16px 0 32px;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.00938em;
  }

  &:hover {
    background-color: ${props => (props.isClubeBlack ? '#2c2c2c' : '#11293f')};
    cursor: pointer;
  }
`;

export const Icon = styled.div`
  color: #fff;
  display: inline-block;
  width: 24px;
  height: 24px;
`;
